module.exports = __webpack_public_path__ + "static/coinstack-5974292925add4c6302dd63cae590e0b.svg";